import { useEffect, useRef, useState } from 'react';
import { Col } from 'antd';
import G6 from '@antv/g6';

function prune_tree(tree) {
  if (tree.tag === tree.text && tree.text?.length === 1)
    return null
  // if (tree.tag.startsWith('N'))
  //   tree.children = []
  tree.children = tree.children?.map(prune_tree).filter(item => item != null)
  if (!tree.children?.length)
    tree.tag = tree.text
  return tree
}

const TreeView = (props) => {
  const containerRef = useRef(null)
  const graphRef = useRef(null)
  const { sent_structure = [{}], sentences } = props;
  const [sentId, setSentId] = useState(0)
  useEffect(() => {
    if (!graphRef.current) {
      const container = containerRef.current
      graphRef.current = new G6.TreeGraph({
        container: container,
        width: container.scrollWidth,
        height: container.scrollHeight || 500,
        linkCenter: true,
        modes: {
          default: [
            {
              type: 'collapse-expand',
              onChange: function onChange(item, collapsed) {
                const data = item.getModel()
                item.update({
                  label: collapsed ? data.text : data.tag, collapsed,
                  position: data.children.length && !collapsed ? 'bottom' : 'right',
                })
                item.refresh()
                return true;
              },
            },
            'drag-canvas',
            'zoom-canvas',
          ],
        },
        defaultNode: {
          size: 26,
          anchorPoints: [
            [0, 0.5],
            [1, 0.5],
          ],
        },
        defaultEdge: {
          type: 'cubic-horizontal',
        },
        layout: {
          type: 'dendrogram',
          direction: 'LR', // H / V / LR / RL / TB / BT
          nodeSep: 40,
          rankSep: 100,
        },
      });
      graphRef.current.node(node => ({
        label: node.collapsed ? node.text : node.tag,
        labelCfg: {
          position: node.children?.length && !node.collapsed ? 'bottom' : 'right',
          style: {
            textAlign: 'start',
          },
        },
      }))
      if (typeof window !== 'undefined') {
        window.onresize = () => {
          if (!graph || graph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
      }
    }
    const graph = graphRef.current
    graph.data(prune_tree(sent_structure[sentId]));
    graph.render();
    graph.fitView();
  }, [sent_structure, sentId]);
  return <>
    <Col span={10} style={{
      height: '100%',
      overflow: 'auto'
    }}><div>{sentences.map(({ id, content }) => <p
      id={`sentence${id}`}
      key={id}
      onClick={() => setSentId(id)}
    >{content}</p>)}</div></Col>
    <Col span={14} style={{
      height: '100%',
      overflow: 'auto'
    }}><div ref={containerRef}></div></Col>
  </>
}
export default TreeView